import { defineMessages } from 'react-intl';

export default defineMessages({
  title: 'Find a board about a specific topic',
  surnamesOrTopics: 'Surnames or topics',
  minimumCharCondition:'Enter at least 3 characters then click \'Go\'.',
  go:'Go',
  surnames:'Surnames',
  noMatches: 'No matches found',
  loading: 'Loading...'
});
